<template>
  <div>
    <DocumentsTable></DocumentsTable>
    <DocumentDetail
      v-if="showDocumentDetail"
      :webkey="showDocumentWebkey"
      :selection="selection"
      @close="closeDocumentDetail"
    ></DocumentDetail>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import DocumentDetail from "./DocumentDetail";
import DocumentsTable from "./DocumentsTable";
export default {
  name: "PanelBottom",
  components: {
    DocumentsTable,
    DocumentDetail
  },
  props: {
    selection: { type: Object }
  },
  data() {
    return {
      showDocumentDetail: false,
      showDocumentWebkey: null,
      collDocQuery: []
    };
  },
  computed: {
    ...mapState({
      documentsCount: state => state.document.documentsCount,
      documentSelection: state => state.document.documentSelection,
      filterFocused: state => state.filter.filterFocused,
      filterQuery: state => state.filter.filterQuery,
      collectionDocs: state => state.collection.collectionDocs
    })
  },
  watch: {
    filterQuery() {
      this.loadFreshDocs("selection");
    },
    filterFocused() {
      this.loadFreshDocs("filter");
    },
    collectionDocs() {
      this.loadFreshDocs("collection");
    }
  },
  mounted() {
    this.loadFreshDocs("selection");
    EventBus.$on("viewDocument", webkey => this.openDocumentDetail(webkey));
  },
  beforeDestroy() {
    EventBus.$off("viewDocument");
  },
  methods: {
    ...mapActions([
      "loadDocuments",
      "loadDocumentSelection",
      "saveDocPanelState",
      "saveFilterQuery"
    ]),
    openDocumentDetail(webkey) {
      if (this.showDocumentDetail) {
        this.showDocumentDetail = false;
      }
      this.showDocumentWebkey = webkey;
      this.showDocumentDetail = true;
      this.saveDocPanelState("expanded");
    },
    closeDocumentDetail() {
      this.showDocumentDetail = false;
      this.saveDocPanelState("default");
    },
    colDocsToQuery(docs) {
      this.collDocQuery = [];
      docs.forEach(d => {
        this.collDocQuery.push({
          _id: d
        });
        this.collDocQuery.push("OR");
      });
      this.collDocQuery.pop();
    },
    loadFreshDocs(initiator) {
      let selection = null;

      if (initiator === "selection") {
        this.$emit("resetCollection");
        selection = this.filterQuery;
      }
      if (initiator === "collection") {
        //this.saveFilterQuery({ query: [] });
        this.colDocsToQuery(this.collectionDocs);
        selection = this.collDocQuery;
      }
      
      this.loadDocumentSelection({ selection: selection });
      this.loadDocuments({
        which: "global",
        page: localStorage.getItem("explore-documents-page") || 1,
        pageSize: localStorage.getItem("explore-documents-per-page") || 10,
        sortOn: "pubdate",
        sortAsc: false
      });
    }
  }
};
</script>
